// extracted by mini-css-extract-plugin
export var active = "_8b-a";
export var activeIndicator = "_8b-8";
export var animate = "_8b-9";
export var disabled = "_8b-b";
export var fullWidth = "_8b-2";
export var lg = "_8b-7";
export var md = "_8b-6";
export var redoButtonTabGroup = "_8b-0";
export var sm = "_8b-5";
export var tabButton = "_8b-3";
export var tabButtonsContainer = "_8b-1";
export var xs = "_8b-4";